import blueprintEditorReducer from '@editor/pages/projects/blueprint-editor/store/blueprintEditor'
// # Blueprint Editor Tools
import BlueprintToolBlueprintCreator from '@editor/pages/projects/blueprint-editor/tools/BlueprintManager/store'
import BlueprintToolPen from '@editor/pages/projects/blueprint-editor/tools/Pen/store'
import BlueprintToolPolygon from '@editor/pages/projects/blueprint-editor/tools/Polygon/store'
import BlueprintToolCircle from '@editor/pages/projects/blueprint-editor/tools/Shapes/Circle/store'
import attentionTextReducer from '@editor/pages/projects/common/AttentionText/store/attentionText'
import editorReducer from '@editor/pages/projects/editor/store/editor'
import editorSettingsReducer from '@editor/pages/projects/editor/store/editorSettings'
import inspectionGroupReducer from '@editor/pages/projects/editor/store/inspectionGroup'
import inspectionItemsReducer from '@editor/pages/projects/editor/store/inspectionItems'
import shapesReducer from '@editor/pages/projects/editor/store/shapes'
// # Editor Tools
import ToolCameraFocusReducer from '@editor/pages/projects/editor/tools/CameraFocus/store'
import ToolCameraProfile from '@editor/pages/projects/editor/tools/CameraProfile/store'
import ToolCustomMeasurementReducer from '@editor/pages/projects/editor/tools/CustomMeasurement/store'
import ToolDepthEstimationReducer from '@editor/pages/projects/editor/tools/DepthEstimation/store'
import ToolGridReducer from '@editor/pages/projects/editor/tools/Grid/store'
import ToolMaskPCDReducer from '@editor/pages/projects/editor/tools/MaskPCD/store'
import ToolPlaneDetectionReducer from '@editor/pages/projects/editor/tools/PlaneDetection/store'
import ToolPolylineReducer from '@editor/pages/projects/editor/tools/Polyline/store/core'
import ToolRebarDetectionReducer from '@editor/pages/projects/editor/tools/RebarDetection/store'
import ToolVolumeEstimationPolygonReducer from '@editor/pages/projects/editor/tools/VolumeEstimation/Polygon/store/volumeEstimation'
import inspectionSheetReducer from '@editor/pages/projects/inspection-sheet/store'
import pcdAlignmentReducer from '@editor/pages/projects/pcd-alignment/store'
import diagramReducer from '@editor/store/diagram'
import featureFlagsReducer from '@editor/store/featureFlags'
import pageReducer from '@editor/store/page'
import systemReducer from '@editor/store/system'
import toolUtilReducer from '@editor/store/tool'
import vertexReducer from '@editor/store/toolUtils/vertex'
import userReducer from '@editor/store/user'
import videoReducer from '@editor/store/video'
import { combineReducers } from '@reduxjs/toolkit'

import debugReducer from '../components/DebugPanel/store'
import commentsReducer from '../pages/projects/common/Comments/store/comments'
import solidMeshReducer from '../pages/projects/common/SolidMeshManager/store'

const reducers = combineReducers({
  debug: debugReducer,

  // # Core components
  system: systemReducer,
  page: pageReducer,
  user: userReducer,
  videos: videoReducer,
  featureFlags: featureFlagsReducer,

  // # Pages
  editor: editorReducer,
  editorSettings: editorSettingsReducer,
  blueprint: blueprintEditorReducer,
  inspectionSheet: inspectionSheetReducer,
  pcdAlignment: pcdAlignmentReducer,

  // # Project page utilities
  solidMesh: solidMeshReducer,

  // # Editor Tools
  // REFACTOR: Rename to toolMaskPCD
  maskPCD: ToolMaskPCDReducer,
  toolGrid: ToolGridReducer,
  toolCustomMeasurement: ToolCustomMeasurementReducer,
  toolVolumeEstimationPolygon: ToolVolumeEstimationPolygonReducer,
  toolCameraProfile: ToolCameraProfile,
  toolCameraFocus: ToolCameraFocusReducer,
  toolRebarDetection: ToolRebarDetectionReducer,
  toolPlaneDetection: ToolPlaneDetectionReducer,
  toolDepthEstimation: ToolDepthEstimationReducer,
  tools: combineReducers({
    polyline: ToolPolylineReducer,
  }),

  // # Blueprint Editor Tools
  bpBlueprintCreator: BlueprintToolBlueprintCreator,
  bpToolPen: BlueprintToolPen,
  bpToolPolygon: BlueprintToolPolygon,
  bpToolCircle: BlueprintToolCircle,

  // # Shared data across pages
  inspectionItems: inspectionItemsReducer,
  inspectionGroup: inspectionGroupReducer,
  attentionText: attentionTextReducer,
  comments: commentsReducer,
  diagram: diagramReducer,
  shapes: shapesReducer,
  toolUtil: combineReducers({
    core: toolUtilReducer,
    vertex: vertexReducer,
  }),
})

export default reducers
